import { CONFIRM_ACCOUNT_SUCCESS, CONFIRM_ACCOUNT_FAILURE } from "../actions/AdminActions";

const initialState = {
    fetched: false,
    activateSuccess: false,
    error: null
}

export default function adminActivateAccountReducer(state = initialState, action) {

    switch (action.type) {
        case CONFIRM_ACCOUNT_SUCCESS:
            return {
                fetched: true,
                activateSuccess: true,
                error: null
            };
        case CONFIRM_ACCOUNT_FAILURE:
            return {
                fetched: true,
                activateSuccess: false,
                error: action.payload
            }
        default:
            return state;
    }
}